const preventDefault = () => {}

export const createEvent = (target: {name: string; value: any}) => ({
  preventDefault,
  target,
})
